import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-plus-button',
  templateUrl: './plus-button.component.html',
  styleUrls: ['./plus-button.component.scss'],
})
export class PlusButtonComponent implements OnInit {
  @Output() onClick = new EventEmitter<void>();
  @Input() label: string;

  constructor() {}

  ngOnInit(): void {}
}
